//страница планирования меню

import React from 'react'; 
import { createPortal } from 'react-dom';
import { ModalWindow, SimpleCalendar, Sliders, ChoiceInRecipe, ModalInfo, SavePdf, Search } from '../../organisms' 
import {Tabs, TabsMenu } from '../../molecules'
import {TooltipLabel} from '../../atoms'
import { useSelector, useDispatch } from 'react-redux'
import { getPlan, updatePlan, deletePlan, updatePlanFood, deleteDishPlan, getRecipeData, postPlanManual, 
  generPlan, copyPlan, addMenuDish, updatePlanPortion, getUserID} from '../../../store/api.js'  
import './Menu.css' 

export function Menu(props) {
  const { currentUser, rate, options, statusUser } = useSelector(state => state.currentUser) 
  const {plans, statusPlan, error} = useSelector(state => state.plans) // Сохраненные планы с сервера
  const {recipesLimitData, } = useSelector(state => state.recipes)  
  const {users, totalCount} = useSelector(state => state.users)
  const today = new Date();
  const pdfRef = React.useRef(null);
  const dispatch = useDispatch();
  const [disabled, setDisabled] = React.useState(false) // меню на время действий
  const [showCalendar, setShowCalendar] = React.useState(false)  // Показывает календарь
  const [showRecipes, setShowRecipe] = React.useState(false)  // Показывает список рецептов для добавления в меню
  const [returnModal, setReturnModal] = React.useState(false)  // Показывает список рецептов для добавления в меню 
  const eventRef = React.useRef()
  const [choiceDate, setChoiceDate] = React.useState([])
  let todayPlan= plans.length > 0 ? plans.filter( i => choiceDate.some( k => i.date === k.date )) : []; 
  const [menu, setMenu] = React.useState([])
  const [changeMenuDay, setChangeMenuDay] = React.useState(false) //маркер изменения меню для пересчета продуктов
  let getLocalDate = JSON.parse(localStorage.getItem('datePoint'));
  const [blockedSaveMenu, setBlockedSaveMenu] = React.useState(false) //Просроченная дата или нет 
  const label1 = rate.subs === 'free'; 
  //const label1 = false
  const [userId, setUserId] = React.useState(false)
  const submitDisabled = blockedSaveMenu || statusPlan === 'loading' || label1 
  const [positionMenuItem, setPositionMenuItem] = React.useState({});  
  const [clickCreate, setClickCreate] = React.useState(false) //Отслеживание клика для вывода прелоудера в меню
  const [optionsId, setOptionId] = React.useState('')
  const [showModal, setShowModal] = React.useState(false) // Показывает информацию(ошибки или успешные действия с сервером)
  const [textsucces, setTextsucces] = React.useState(''); // Текст для ошибки 
  const [iconVisual,setIconVisual] = React.useState(false); //Иконка для ошибки 
  const [isOpenSet, setIsOpenSet] = React.useState(false);
  
  React.useEffect(() => { 
    if(choiceDate.length === 0 && (getLocalDate?.length === 0 || getLocalDate === null)) {
      setChoiceDate([{date: today.setHours(0,0,0,0)}])
    } else if(getLocalDate.length > 0) {
      setChoiceDate(getLocalDate)
    }
  },[])
 

   const handleUserActive = async () => { 
  try {
    // 1. Сначала получаем данные пользователя
    await dispatch(getUserID(userId));
    
    // 2. После успешного получения пользователя, берем его ID
    if (Object.keys(users).length !== 0) {
      const userId = users[0].option[0]._id;
      // 3. Запрашиваем планы по найденному userId
      await dispatch(getPlan(userId));
    }
  } catch (error) {
    console.error('Error in handleUserActive:', error);
  }
} 

  React.useEffect(() => {
  const handlePopState = () => { 
    setShowRecipe(false); // Всегда закрываем модалку при "Назад"
  };

  window.addEventListener("popstate", handlePopState);
  return () => window.removeEventListener("popstate", handlePopState);
}, []);
 
 
  React.useEffect(() => {
    if (isOpenSet || showRecipes) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    } 
    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
   }, [isOpenSet, showRecipes]);
 

  React.useEffect(() => { 
    if (statusPlan === 'rejected' && error) { 
      errorHandler(statusPlan, error);  
    } else if (statusPlan === 'resolved') {
      setClickCreate(false)
      setReturnModal(false)
    }
  }, [error,statusPlan]);


  const errorHandler = (status, error) => { 
    
    setShowModal(true);
    setIconVisual(false);
    setTextsucces(error || "Неизвестная ошибка, попробуйте позже"); 
 
  } 

  function handleModalClose() { 
    setShowModal(false)  
  }
  
  React.useEffect(() => {
    const click = e => {
      if (showCalendar && eventRef.current && !eventRef.current.contains(e.target) && !e.target.classList.contains('buttonGreen') ) {
        setShowCalendar(false)
      }
     }
    document.addEventListener("mousedown", click)
      return () => {
        document.removeEventListener("mousedown", click)
      }
  }, [showCalendar])

  React.useEffect(() => {
    if(plans.length > 0) {
      searchPlanData()
    }  
    if(choiceDate.length > 0) {
      const newplan = choiceDate.map(c=> {
        const foundItem = plans.find(item => item.date === c.date);
        return foundItem ? foundItem : c;
      }) 
      setMenu(newplan)
    }
  },[plans, choiceDate]) 

 
  function searchPlanData() {
    let todayMenuBase = plans.filter( i => choiceDate.some( k => i.date === k.date )); //ищем сгенерированные меню на выбранные даты сохраненные в базе
    const arrMenu = todayMenuBase.map(item => {
      return [
        ...(item.breakfast || []),
        ...(item.dinner || []),
        ...(item.supper || []),
        ...(item?.snack || []),
        ...(item.lunch || []),
        ...(item.lateDinner || [])
      ];
    }) 
    
    const mergedArray = Array.from(new Set(arrMenu.flat().map(item => 
      typeof item === 'object' && item !== null ? item.id || item._id : item
    ))).filter(Boolean);;
    if (recipesLimitData.length === 0) { 
      // Получение фотографий и данных для отображения рецептов в плане 
      dispatch(getRecipeData(mergedArray))
    } else { 
      const news = mergedArray.filter(m=> !recipesLimitData.find(r=> r._id === m) )
      if(news.length > 0) {
        dispatch(getRecipeData(news))
      }
    }  
  }
  //Открытие и закрытие календаря для добавления в рецепт
  function handleOpenCalendar() { 
    setShowCalendar(!showCalendar)
  }

  function handleAddRecipeinMeals() {
    setShowCalendar(false)
  } 
  function handleClose() { 
    setShowRecipe(false)
    setIsOpenSet(false)  
    if (window.history.state?.modalOpen) {
      window.history.back(); // Опционально
    }
  }
  
  function cleanMealPlan(mealPlan) {
    // Создаем копию объекта, чтобы не мутировать исходный
    const cleanedPlan = JSON.parse(JSON.stringify(mealPlan));
  
    // Поля, которые нужно очистить
    const mealFields = ['breakfast', 'dinner', 'supper', 'lunch', 'lateDinner', 'snack'];
  
    // Устанавливаем каждое поле как пустой массив
    mealFields.forEach(field => {
      cleanedPlan[field] = [];
    });
  
    return cleanedPlan;
  }

                                            /* КАЛЕНДАРЬ*/
  //Обновляет выбранные даты в календаре, если даты старые блокирует изменения,если нет то записывает дату в стэйт
  function handleDateRange(data) { 
    setChangeMenuDay(false)
    const blockedSaveMenu = data.some((i)=> {
      return i.date < today.setHours(0,0,0,0)
    })
    localStorage.setItem('datePoint', JSON.stringify(data));
    setBlockedSaveMenu(blockedSaveMenu)
    setChoiceDate(data)
  } 


  

                              /* Обработка данных для поиска в модальном окне*/ 
  // Передает данные в модалку для замены рецепта
  function handleEdite(id, mealsEn, mealsRu, index, item) { 
    setShowRecipe(true)
    window.history.pushState({ modalOpen: true }, "");
    setPositionMenuItem({
      id,
      powerMode: mealsEn,
      powerModeRu: mealsRu,
      item: item,
      index: index,
      replace: true,
    })
  } 
  
  // Передает входные данные в модалку для добавления рецепта в план
  function handleAddExcessDish(mealsRu, mealsEn, item) {
    setShowRecipe(true) 
    window.history.pushState({ modalOpen: true }, "");
    setPositionMenuItem({
    powerMode: mealsEn,
    powerModeRu: mealsRu,
    day: item.date,
    item: item,
    replace: false,
    excess: true,
    })
  } 

    // Передает входные данные в модалку для добавления рецепта в план
  function handleAddDish(mealsRu, mealsEn, item) {
    setShowRecipe(true)
    window.history.pushState({ modalOpen: true }, "");
    setPositionMenuItem({
    powerMode: mealsEn,
    powerModeRu: mealsRu,
    day: item.date,
    item: item,
    replace: false
    })
  }

                                            /* КОНСТРУКТОР ПЛАНА*/


function handleChangeMenuDay() { 
  setChangeMenuDay(true)
}

function handleChangeMenu() {
  setChangeMenuDay(false)
}

                                     /* РУЧНАЯ КОРРЕКТИРОВКА МЕНЮ*/ 
                                
    //функция ручного добавления рецепта в меню!!!
  function handleAddFirstRecipe(recipe, powerMode, item) {  
    dispatch(postPlanManual({date: [{date: item.date}], mealType: powerMode, recipeId: recipe._id, title: optionsId, flag: 'inPlan'}))
    handleChangeMenuDay()
  }

  //Удаление из плана меню целого дня!!!
  function handleDeleteMenuDay(id) {
      dispatch(deletePlan(id))
      handleChangeMenuDay()
  }                                   
    
  //Дополнительное добавления блюда в прием пищи !!!
  function addExcessRecipe(recipe, powerMode, item) {  
    dispatch(postPlanManual({date:[{date: item.date}], mealType: powerMode, recipeId: recipe._id, title: optionsId, flag: 'inPlan'}))
    handleChangeMenuDay()
  }
  
  //функция удаления рецепта из плана!!!
  function handleDeleteRecipe(id, powerMode, index, item) { 
    dispatch(deleteDishPlan({planId: item, id: id, mealType: powerMode, index: index})) 
    handleChangeMenuDay()
  } 

  //функция ручной замены рецепта в плане !!!
  function handleReplace(id, recipe, powerMode, item, index, ) {  
    dispatch(updatePlanFood({planId: item, id: id, mealType: powerMode, recipeId: recipe._id, index: index, title: optionsId}))
    handleChangeMenuDay()
    setReturnModal(true)
  } 

                                   /* Автообновление плана питания*/ 
 
  // Генерация меню !!!                                
  function handleGeneration() {  
      if(blockedSaveMenu) {
        props.blockedSaveMenu('blockedSaveMenu') 
      } else {
        //setDisabled(true)
        setClickCreate(true); 
        dispatch(generPlan({choiceDate, title: optionsId}))
        handleChangeMenuDay() 
      }
  } 
    //функция замены плана на день!!!
    function handleAutoReplaceMenu(item) {  
      dispatch(generPlan({choiceDate: [{date: item.date}], title: optionsId}))
      handleChangeMenuDay() 
    } 

 //Автозамена рецепта на день!!!
    function handleAutoReplaceDish(id, cal, category, mealsEn, index, item) {   
      handleChangeMenuDay() 
      dispatch(updatePlan({planId: item, id, cal, category, mealType: mealsEn, index: index, title: optionsId}))
    }
 
    //Копирование рецепта на др день!!
    function handleCopyRecipe(el, recipeId) { 
      dispatch(postPlanManual({date: el.dataDate, mealType: el.title.mealsEn, recipeId, title: optionsId, flag: 'inPlan'}))
    }

   //Копирование плана на др день!!
    function handleCopyPlan(date, planId) {  
     dispatch(copyPlan({dates: date, planId: planId, title: optionsId}))
    }
   // Автодобавление приема пищи в план
   function handleAutoMeals(mealsEn, id) { 
    dispatch(addMenuDish({mealType: mealsEn, planId: id, title: optionsId}))
    handleChangeMenuDay() 
   }

  function handleEditMenu(tab) {
    setOptionId(tab.id)
    dispatch(getPlan(tab.id))
  } 
 
  const toggleModal = () => {  
    setTimeout(() => {
      setShowRecipe(false); 
      setIsOpenSet(false); 

      if (window.history.state?.modalOpen) {
        window.history.back(); // Опционально
      }
    }, 300); // Должно совпадать с duration анимации
  
};

function hadleOpenCastom() { 
  setIsOpenSet(true)
}
function handleInfoModal() {
  props.infoModal() 
  setIsOpenSet(false)
}

function handleChangeCount(servings, weight, itemId, category, mealsEn, index, planId) {    
  dispatch(updatePlanPortion({servings, weight, planId, itemId, category, mealType: mealsEn, index: index, title: optionsId}))
}

 function handleChangeInput(e) { 
      setUserId(e.target.value)   
    }

  return ( 
    <>
      <Search onSearch={handleChangeInput} keyword={userId} placeholder='Искать по id'/>
       <button className='my-recipe__add-button' onClick={handleUserActive}>Найти пользователя</button> 
      <title>Конструктор плана питания 🍏 – Автоподбор меню по параметрам | MENUBOOK.</title>
      <meta name="description" content='Создайте индивидуальный план питания с учетом калорий, аллергенов и предпочтений. Автоподбор блюд, стоп-лист продуктов, списки покупок и техники готовки. Готовьте с удовольствием!' /> 
      <section className='menu-heading flexColCenter'>
      <h1 className='font32EB color'>Ваше меню</h1> 
      <p className='font20EB colorGrey menu__subtitle'>Составьте меню на любое количество дней</p> 
      </section>
      {  !label1 && rate.subs !== 'standart' &&
      <section className='menu-tabs flexColCenter'> 
        <TabsMenu  handleEditMenu= {handleEditMenu} />
      </section>
     }
    
    <div className='menu__content'>
    <section className='menu__control'>
      <div className='menu-heading__control flexRowCenter fw'>
        <button type='button' 
        className={`buttonGreen button_maxi ${(submitDisabled || disabled)? ('buttonDisabled') : ''}`}  
        onClick={hadleOpenCastom}>Параметры меню
        {label1 &&  <TooltipLabel pre='Параметры доступны для ознакомления, редакторование и сохранение' declension='Возможно' content='Стандарт' subcontent= '' /> }
        </button>
        <div className='menu-heading__calendars'>
        <button type='button' className='buttonGreen button_maxi' onClick={handleOpenCalendar}>Выберите даты </button>
        <SimpleCalendar 
          meals={[]} 
          userMenu={plans} 
          isOpen={showCalendar} 
          dateDay={choiceDate} 
          ref={eventRef} 
          handleAddRecipeinMeals={handleAddRecipeinMeals} 
          type='menu'  
          onDayRange={handleDateRange}/> 
        </div>
        <button type='button' className={`buttonGreen button_maxi ${(submitDisabled || disabled)? ('buttonDisabled') : ''}` }  
          disabled={submitDisabled || disabled} onClick={handleGeneration} >{todayPlan.length > 0 ? 'Обновить меню' : 'Создать меню'}
        {label1 &&  <TooltipLabel pre='Автоматическое создание меню' content='Стандарт' subcontent= 'и выше' declension='Доступно'/> }
        </button>   
      </div>
      </section>
    
    <section  ref={pdfRef} className='menu-list'> 
        <Sliders 
          choiceDate={choiceDate} 
          handleAddDish={handleAddDish}
          products={menu}
          clickCreate={clickCreate}
          handleChangeCount={handleChangeCount}
          handleDeleteMenuDay={handleDeleteMenuDay}
          handleAddExcessDish={handleAddExcessDish}
          handleDeleteRecipe={handleDeleteRecipe}
          handleEdite={handleEdite}
          blockedSaveMenus={props.blockedSaveMenus }
          handleAutoReplaceMenu={handleAutoReplaceMenu}
          handleAutoReplaceDish={handleAutoReplaceDish}
          handleCopyRecipe={handleCopyRecipe}
          handleCopyPlan={handleCopyPlan}
          handleAutoMeals={handleAutoMeals}
          optionsId={optionsId} 
          showRecipes={showRecipes}
          returnModal={returnModal}
          changeMenuDay={changeMenuDay}
        />
         
      </section>
     {/*<MenuProduct 
       choiceDate={choiceDate}
       todayPlan={todayPlan}
       changeMenuDay={changeMenuDay}
       handleChangeMenu={handleChangeMenu}
       optionsId={optionsId}
     /> */}
   
    </div>
    {/*Открытие настроек/параметров меню пользователя */}
    {isOpenSet &&
      <ModalWindow  onClose={handleClose} title='castom' head='Параметры меню' toggleModal={toggleModal}>
        <Tabs infoModal={handleInfoModal}/>
      </ModalWindow>
    }
      {/*Открытие модалки с рецептами для ручного редактирования плана */}
      {showRecipes && createPortal(
        <ModalWindow  isOpen={showRecipes} onClose={handleClose} title='show-recipe' head='Параметры меню' toggleModal={toggleModal}>
      <ChoiceInRecipe 
        addRecipe={handleAddFirstRecipe}   
        loggedIn={props.loggedIn}
        onClose={handleClose} 
        closeModal={handleClose} 
        positionMenuItem={positionMenuItem} 
        addExcessRecipe={addExcessRecipe}
        replaceRecipe={handleReplace} 
      /> 
    </ModalWindow>, 
       document.body
       )}
      {showModal &&
        <ModalInfo  textError={textsucces} onClose={handleModalClose} icon={iconVisual} name="modal-info" />
      }
   
    </>
  ) 
}
 